export default {
  methods: {
    setToclist(repeat = 1) {
      if (repeat > 0 && repeat < 4) {
        for (let i = 0; i < repeat; i += 1) {
          this.layout.tocList[this.tabIndex].class = 'visited';
          this.layout.tocList[
            this.tabIndex + 1
          ].class = `active ${this.activeBeforeEffect(this.tabIndex + 1)}`;
          this.tabIndex += 1;
        }
      } else if (repeat === -1) {
        this.layout.tocList[this.tabIndex].class = '';
        this.layout.tocList[
          this.tabIndex - 1
        ].class = `active ${this.activeBeforeEffect(this.tabIndex - 1)}`;
        this.tabIndex -= 1;
      } else {
        this.$router
          .replace({
            query: {
              ...this.$route.query,
            },
          })
          .catch(() => {});
      }
    },

    async clickedStepperItem(index) {
      const isValid = (await this.$refs.observer.validate()) || index === 0;
      if (typeof isValid !== 'undefined' && isValid) {
        window.scrollTo(0, 0);
        this.setTocListClassChange(index, this.activeBeforeEffect(index));
        this.tabIndex = index;
        this.$router
          .replace({
            query: {
              ...this.$route.query,
            },
          })
          .catch(() => {});
      }
    },

    async clickedStepperItemOtherTypes(index) {
      this.setTocListClassChange(index, this.activeBeforeEffect(index));
      this.tabIndex = index;
    },

    activeBeforeEffect(index) {
      let beforeEffect;
      if (this.layout.tocList[index].class !== '') {
        beforeEffect = 'visitedActive';
      }

      return beforeEffect;
    },

    setTocListClassChange(index, befforeEffect) {
      if (index > this.tabIndex) {
        this.layout.tocList = this.layout.tocList.map((item, i) => {
          let tempClass;
          if (this.tabIndex <= i && i < index) {
            tempClass = 'visited';
          }

          if (index === i) tempClass = `active ${befforeEffect}`;

          return {
            ...item,
            class: tempClass || item.class,
          };
        });
      } else {
        this.layout.tocList[this.tabIndex].class = 'visited';
        this.layout.tocList[index].class = `active ${befforeEffect}`;
      }
    },
  },
};
